<template>
    <div class="text-center">
        <refill-brand-warning />

        <div class="mt-3">
            <div>
                <font-awesome-icon
                    class="text-success"
                    icon="fa-light fa-check-circle"
                    size="5x"
                />
            </div>
            <h3 class="mt-3">
                {{ $t("Purchase Successful") }}
            </h3>
        </div>

        <div class="mt-3">
            <h5 class="mb-0">
                <font-awesome-icon
                    icon="fa-duotone fa-coin"
                    class="text-warning"
                />
                {{ price.credits }}
                {{ $t("Credits") }}
            </h5>
            <div class="text-secondary">
                {{ price.label }}
            </div>
        </div>

        <b-btn
            @click="closeWallet"
            variant="primary"
            class="mt-3"
            pill
            block
            size="lg"
        >
            {{ $t("Close Wallet") }}
        </b-btn>
    </div>
</template>

<script>
import { mapState } from "vuex";

import RefillBrandWarning from "@/components/wallet/refill/RefillBrandWarning";

export default {
    computed: {
        ...mapState("wallet", ["price"]),
    },
    methods: {
        closeWallet() {
            this.$store.dispatch("onboarding/status");
            this.$store.commit("wallet/reset");
            this.$store.commit("interface/setUserWalletModalVisible", false);
        },
    },
    components: {
        RefillBrandWarning,
    },
};
</script>
